import React from 'react';
import styled from 'styled-components';
import BottomTabBar from '../BottomTabBar/BottomTabBar';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #0a0a0f;
`;

const Main = styled.main`
  flex: 1;
  padding-bottom: 72px;
  overflow-x: hidden;
`;

const Layout = ({ children }) => (
  <Wrap>
    <Main>{children}</Main>
    <BottomTabBar />
  </Wrap>
);

export default Layout;
